module.exports = __webpack_public_path__ + "static/media/27.e1c10c90.jpeg";